<template>
  <div>
    <div class="w3-container">
      <div class="headerGridCMSSearchSort w3-hide-print">
        <div class="d-none d-sm-block">
          <header>
            <h2>Products</h2>
          </header>
        </div>
        <div class="headerRightGrid2">
          <div>
            <div class="customSelect mt-2 noselect">
              <div class="selectedCustomSelect" :class="showCustomSelect1 ? 'active' : ''" @click="showCustomSelect1 = !showCustomSelect1"><span :class="state.selectedCategory.title ? 'colorDark' : ''">{{state.selectedCategory.title || 'Choose Category'}}</span> <span style="float:right; padding:0 6px;" @click.stop="state.selectedCategory = {title: null}" v-if="state.selectedCategory.title"><i class="fa fa-times"></i></span></div>
              <div class="customSelectContainer" v-if="showCustomSelect1">
                <div class="customSelectPosition">
                  <div v-for="(category, index) in state.siteData.content.products.categories" :key="index" class="customSelectItem" @click="selectCategory(category); showCustomSelect1 = false">
                    <span class="customSelectTitle">{{category.title}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-none d-sm-block">
            <input class="w3-input w3-round dark vmiddle" placeholder="Search Products..." v-model="searchProductTerm" style="font-size:10pt;" />
          </div>
          <div class="w3-right-align">
            <router-link to="/cms/products-detail" class="w3-button w3-teal vmiddle" style="font-size:10pt;">
              New Product
            </router-link>
          </div>
        </div>
      </div>
      <div class="inputCard">
        <nav aria-label="Page navigation" style="float:right; margin:4px 4px 0;">
          <ul class="pagination" style="margin-bottom:0;">
            <li class="page-item pointer noselect pageButton" @click="gotoPage('-1')"><span class="page-link"><i class="fa fa-chevron-left" style="font-size:12px; margin-top:1px;"></i></span></li>
            <li class="page-item pointer noselect" @click="gotoPage(index)" v-for="index in productLength" :key="index" :class="activePage === index ? 'active':''"><span class="page-link">{{index}}</span></li>
            <li class="page-item pointer noselect pageButton" @click="gotoPage('+1')"><span class="page-link"><i class="fa fa-chevron-right" style="font-size:12px; margin-top:1px;"></i></span></li>
          </ul>
        </nav>
        <header>Products</header>
        <div class="content">
          <div class="d-none d-sm-block">
            <div class="productsTableGrid w3-border-bottom productsTableHeader">
              <div class="pointer" @click="sortBy('order')">Order<span v-if="sortCol === 'order'"><i style="margin-left:6px;" :class="[sortSwitch ? 'fa fa-caret-up' : 'fa fa-caret-down','w3-text-teal']"></i></span></div>
              <div>Image</div>
              <div class="pointer" @click="sortBy('title')">Title<span v-if="sortCol === 'title'"><i style="margin-left:6px;" :class="[sortSwitch ? 'fa fa-caret-up' : 'fa fa-caret-down','w3-text-teal']"></i></span></div>
              <div class="pointer" @click="sortBy('category')">Category<span v-if="sortCol === 'category'"><i style="margin-left:6px;" :class="[sortSwitch ? 'fa fa-caret-up' : 'fa fa-caret-down','w3-text-teal']"></i></span></div>
              <!-- <div class="d-none d-sm-block pointer" @click="sortBy('brand')">Brand<span v-if="sortCol === 'brand'"><i style="margin-left:6px;" :class="[sortSwitch ? 'fa fa-caret-up' : 'fa fa-caret-down','w3-text-teal']"></i></span></div> -->
              <div class="w3-right-align">Qty</div>
              <div class="w3-right-align">Price</div>
              <div class="w3-center pointer" @click="sortBy('status')">Status<span v-if="sortCol === 'status'"><i style="margin-left:6px;" :class="[sortSwitch ? 'fa fa-caret-up' : 'fa fa-caret-down','w3-text-teal']"></i></span></div>
              <div class="w3-center">Actions</div>
            </div>
          </div>
          <div class="d-none d-sm-block">
            <div class="productsTableGrid tableRow" v-for="(product, index) in sortProducts()" :key="index">
              <div class="productOrder">{{product.order}}</div>
              <div style="margin:0 auto;" class="tableImage" :style="{'background-image': 'url(' + productImage(product.images[0]['src']) + ')'}"></div>
              <div class="productTitle truncate">{{product.title}}</div>
              <div>{{categoryName(product.category)}}</div>
              <!-- <div class="d-none d-sm-block">{{product.brand}}</div> -->
              <div class="w3-right-align">{{product.quantity}}</div>
              <div class="w3-right-align">{{productPrice(product.price)}}</div>
              <div class="w3-center">{{product.status}}</div>
              <div>
                <div class="buttons row2" style="grid-gap:2px;">
                  <router-link tag="button" :to="'/cms/products-detail/' + product.id" class="w3-button w3-small w3-teal w3-block">Edit</router-link>
                  <button class="w3-button w3-small w3-red w3-block" @click="deleteProduct(product.id)">Delete</button>
                </div>
              </div>
            </div>
          </div>
          <div class="d-sm-none">
            <div class="mobileProduct" v-for="(product, index) in sortProducts()" :key="index">
              <div class="mobileProductImageContainer">
                <div class="mobileProductImage" :style="{'background-image': 'url(' + productImage(product.images[0]['src']) + ')'}"></div>
              </div>
              <div class="mobileProductContent">
                <div class="mobileTitle truncate">{{product.title}}</div>
                <div style="font-size:14px; font-style:italic;">{{categoryName(product.category)}}</div>
                <div class="w3-right-align" style="font-size:13px;"><i class="fa fa-circle" :class="product.status == 'active' ? 'w3-text-green' : 'w3-text-red'" style="margin-right:5px;"></i>{{productPrice(product.price)}}</div>
              </div>
              
              <!-- <div>
                <div class="buttons row2" style="grid-gap:2px;">
                  <router-link tag="button" :to="'/cms/products-detail/' + product.id" class="w3-button w3-small w3-teal w3-block">Edit</router-link>
                  <button class="w3-button w3-small w3-red w3-block" @click="deleteProduct(product.id)">Delete</button>
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <!-- pagination -->
        <div class="bg-dark" style="height:44px; border-radius:0 0 3px 3px;">
          <nav aria-label="Page navigation" style="float:right; margin:4px;">
            <ul class="pagination" style="margin-bottom:0;">
              <li class="page-item pointer noselect pageButton" @click="gotoPage('-1')"><span class="page-link"><i class="fa fa-chevron-left" style="font-size:12px; margin-top:1px;"></i></span></li>
              <li class="page-item pointer noselect" @click="gotoPage(index)" v-for="index in productLength" :key="index" :class="activePage === index ? 'active':''"><span class="page-link">{{index}}</span></li>
              <li class="page-item pointer noselect pageButton" @click="gotoPage('+1')"><span class="page-link"><i class="fa fa-chevron-right" style="font-size:12px; margin-top:1px;"></i></span></li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var slug = require('slug')
var dataStore = require('../../dataStore').default

export default {
  name: 'cmsproducts',
  data() {
    return {
      state: dataStore.state,
      newCategory: {
        id: 0,
        title: '',
        image: '',
        parentid: 0,
        slug: ''
      },
      searchProductTerm: '',
      activePage: 1,
      showCustomSelect1: false,
      sortCol: '',
      sortSwitch: true
    }
  },
  computed: {
    products() {
      if (this.state.selectedCategory.title) {
        if (!this.searchProductTerm || this.searchProductTerm === '') {
          if (this.activePage) {
            return this.state.siteData.content.products.items.filter(item => item.category === this.state.selectedCategory.id).slice((this.activePage - 1) * 36, this.activePage * 36)
          } else {
            return this.state.siteData.content.products.items.filter(item => item.category === this.state.selectedCategory.id).slice(0, 36)
          }
        } else {
          if (this.activePage) {
            return this.state.siteData.content.products.items.filter(item => (item.title.toLowerCase().includes(this.searchProductTerm.toLowerCase()) && item.category === this.state.selectedCategory.id)).slice((this.activePage - 1) * 36, this.activePage * 36)
          } else {
            return this.state.siteData.content.products.items.filter(item => (item.title.toLowerCase().includes(this.searchProductTerm.toLowerCase()) && item.category === this.state.selectedCategory.id)).slice(0, 36)
          }
        }
      }
      if (!this.searchProductTerm || this.searchProductTerm === '') {
        if (this.activePage) {
          return this.state.siteData.content.products.items.slice((this.activePage - 1) * 36, this.activePage * 36)
        } else {
          return this.state.siteData.content.products.items.slice(0, 36)
        }
      } else {
        if (this.activePage) {
          return this.state.siteData.content.products.items.filter(item => item.title.toLowerCase().includes(this.searchProductTerm.toLowerCase())).slice((this.activePage - 1) * 36, this.activePage * 36)
        } else {
          return this.state.siteData.content.products.items.filter(item => item.title.toLowerCase().includes(this.searchProductTerm.toLowerCase())).slice(0, 36)
        }
      }
    },
    productLength() {
      if (this.state.selectedCategory.title) {
        return Math.ceil(this.state.siteData.content.products.items.filter(item => item.category === this.state.selectedCategory.id).length / 36)
      }
      if (!this.searchProductTerm || this.searchProductTerm === '') {
        return Math.ceil(this.state.siteData.content.products.items.length / 36)
      } else {
        return Math.ceil(this.state.siteData.content.products.items.filter(item => item.title.toLowerCase().includes(this.searchProductTerm.toLowerCase()) || item.description.toLowerCase().includes(this.searchProductTerm.toLowerCase())).length / 36)
      }
    }
  },
  methods: {
    gotoPage(page) {
      if (page === '-1') {
        if (this.activePage > 1) {
          this.activePage--
        }
      } else if (page === '+1') {
        if (this.activePage < Math.ceil(this.state.siteData.content.products.items.length / 36)) {
          this.activePage++
        }
      } else {
        this.activePage = page
      }
    },
    productPrice(price) {
      if (Number(price) === 0) {
        return 'Quote'
      } else {
        // console.log(price)
        return '$' + Number(price).toFixed(2)
      }
    },
    setParent(parent) {
      this.newCategory.parentid = parent.id
    },
    sortBy(col) {
      if (this.sortCol === col) {
        this.sortSwitch = !this.sortSwitch
      } else {
        this.sortSwitch = true
      }
      this.sortCol = col
    },
    selectCategory(category) {
      this.state.selectedCategory = category
    },
    sortProducts( ) {
      if (this.sortCol !== '') {
        function compareValues(key, order = 'asc') {
          console.log(order)
          return function innerSort(a, b) {
            if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
              return 0;
            }
            const varA = (typeof a[key] === 'string') ? a[key].toLowerCase() : a[key];
            const varB = (typeof b[key] === 'string') ? b[key].toLowerCase() : b[key];
            let comparison = 0;
            if (varA > varB) {
              comparison = 1;
            } else if (varA < varB) {
              comparison = -1;
            }
            return (
              (order === 'desc') ? (comparison * -1) : comparison
            );
          };
        }
        return this.products.sort(compareValues(this.sortCol, this.sortSwitch ? 'asc' : 'desc'))
      } else {
        return this.products
      }
    },
    saveContent() {
      this.saving = true
      dataStore.saveSiteProducts().then((res) => {
        this.saving = false
        if (res === 'success') {
          this.saved = true
          setTimeout(() => {
            this.saved = false
          }, 2000)
        }
      })
    },
    deleteProduct(id) {
      let itemIndex = this.state.siteData.content.products.items.findIndex(savedProduct => savedProduct.id === id)
      if (itemIndex > -1) {
        if (confirm('Really DELETE ' + this.state.siteData.content.products.items[itemIndex].title + ' product?')) {
          this.state.siteData.content.products.items.splice(itemIndex, 1)
          this.saveContent()
        }
      }
    },
    productImage(img) {
      if (img) {
        return img
      } else {
        return 'https://levelsevenstudio.com/api/images/levelsevenstudio.com/placeholder-square.png'
      }
    },
    categoryName(id) {
      let itemIndex = this.state.siteData.content.products.categories.findIndex(savedCategory => savedCategory.id === id)
      if (itemIndex > -1) {
        return this.state.siteData.content.products.categories[itemIndex].title
      } else {
        return 'None'
      }
    },
    findCategoryBySlug(categoryName) {
      let searchSlug = slug(categoryName)
      let itemIndex = this.state.siteData.content.products.categories.findIndex(savedCategory => savedCategory.slug === searchSlug)
      if (itemIndex > -1) {
        return this.state.siteData.content.products.categories[itemIndex]
      } else {
        return 'None'
      }
    }
  }
}
</script>

<style scoped>
  .cmsProductsPageGrid {display:grid; grid-template-columns: 1fr 2fr; grid-gap: 8px;}
  .productsTableGrid .buttons button {padding:4px;}
  .categoryName {padding-left:8px;}
  .input-row-button {display:grid; grid-template-columns: 1fr 1fr 60px; grid-gap: 8px;}

  .colorDark {color:#212121;}
  .content {clear:both; padding:0 8px;}

  .productsContentGrid {display:grid; grid-template-columns: repeat(auto-fill, minmax(250px, 1fr)); grid-gap: 8px;}
  .productsTableGrid {display:grid; grid-template-columns: 56px 50px auto 180px 60px 80px 80px 100px; grid-gap: 8px; padding:8px;}
  .tableRow {border-bottom:1px solid #eee; font-family: 'Roboto'; font-size:11pt;}
  .tableRow:nth-child(even) {background:#fafafa;}
  .tableRow:last-child {margin-bottom:0;}

  .productsTableHeader {font-weight:bold; font-family: 'Roboto'}
  .cardImage {height:150px; width:100%; overflow:hidden; background-position: center; background-size: cover;}
  .tableImage {height:30px; width:30px; overflow:hidden; background-position: center; background-size: cover;}

  .headerRightGrid {display: grid; grid-template-columns: 1fr 115px; grid-gap:8px;}
  .headerRightGrid2 {display: grid; grid-template-columns: 230px 1fr 115px; grid-gap:8px;}

  .buttons {text-align: right; margin-bottom:0;}
  .inputCard header {text-align: left; padding-left:12px;}

  .v-select.searchable .dropdown-toggle {height:36px;}

  .page-link {color:#00897b;}
  .page-item.active .page-link {background:#00897b; border-color: #00796d;}
  .pageButton {display:flex; align-items:center; justify-content: center; height:35px;}
  .productsTableGrid div {align-self: center;}

  .mobileProduct {display: grid; grid-template-columns: 60px 1fr; grid-gap: 10px; padding: 8px; margin-top: 8px; border-radius: 10px; background: #fafafa; overflow: hidden;}
  .mobileProductImage {height:60px; width:60px; background-size: cover; background-position: center;}
  .mobileTitle {font-size:14px; font-weight: 700; max-width: 400px;}

  @media screen and (max-width:993px) {
    .productsTitle {font-size:10pt;}
    .productsMeta {font-size:10pt; font-family: 'Roboto', sans-serif;}
    /* .productsTableGrid.tableRow {grid-template-columns: 1fr; padding:8px 0;} */
    /* .productsTableGrid.tableHeader {width:100%; height:250px;} */
    /* .tableImage {width:100%; height:250px;} */

    .productTitle {font-size:1.25rem; text-align:center;}

    .headerGridCMSSearchSort {grid-template-columns: 1fr;}
    .headerRightGrid2 {grid-template-columns: 1fr 120px;}
  }
  @media screen and (max-width:600px) {
    .content {padding:0; background:none;}
    .inputCard {box-shadow: none;}
    .mobileTitle {max-width: 250px;}
  }
</style>



// WEBPACK FOOTER //
// src/components/cms/cmsProducts.vue